import { ReactNode, useRef } from 'react';
import { createPortal } from 'react-dom';

export const Portal = ({ containerId = 'modals', children }: { containerId?: string; children: ReactNode }) => {
  const containerRef = useRef(document.getElementById(containerId));

  if (!containerRef.current) {
    return null;
  }

  return createPortal(children, containerRef.current);
};
